// extracted by mini-css-extract-plugin
export default {"masterlayoutside-navbar":"ContainerLayout_masterlayoutside-navbar__snwDT","masterlayoutside-main":"ContainerLayout_masterlayoutside-main__S80pf"};